import { render, staticRenderFns } from "./contacts-tppwb.vue?vue&type=template&id=13d4343b&scoped=true&"
import script from "./contacts-tppwb.ts?vue&type=script&lang=ts&"
export * from "./contacts-tppwb.ts?vue&type=script&lang=ts&"
import style0 from "./contacts-tppwb.scss?vue&type=style&index=0&id=13d4343b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4343b",
  null
  
)

export default component.exports